export const GET_DEVICE_MDVR_GROUP = "V3_GET_DEVICE_MDVR_GROUP";
export const GET_DEVICE_MDVR_GROUPS = "V3_GET_DEVICE_MDVR_GROUPS";